// extracted by mini-css-extract-plugin
export default {"passwordReset":"passwordReset_passwordReset__d5AuP"};